import { PROFILES_ENDPOINTS } from "./endpoints";
import type { UserProfile } from "./types";
import { apiRequestWithData } from "../shared";

export default async function getProfile(): Promise<UserProfile> {
  return apiRequestWithData<UserProfile>(PROFILES_ENDPOINTS.GET);
}
